<ng-select
  [(ngModel)]="value"
  class="er-select"
  [items]="items"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [groupBy]="groupBy"
  [multiple]="true"
  [notFoundText]="'shared.components.dropdown.notFound' | transloco"
  [closeOnSelect]="false"
  [searchable]="true"
  (change)="onSelectChange($event)"
  [disabled]="isDisabled"
  [clearable]="clearable"
  [class.ng-invalid]="invalid"
  [class.ng-touched]="invalid"
>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-item$="item$"
    let-index="index"
  >
    <div class="dropdown-element">
      <ed-checkbox
        [disabled]="
          minOneRequired &&
          selectedElementsCleaned().includes(item[bindValue]) &&
          selectedElementsCleaned().length === 1
        "
        [checked]="selectedElementsCleaned().includes(item[bindValue])"
      >
        <div
          [title]="
            useTranslations ? (item[bindLabel] | transloco) : item[bindLabel]
          "
          class="checkbox-label font-semibold text-[0.9rem]"
        >
          {{
            useTranslations ? (item[bindLabel] | transloco) : item[bindLabel]
          }}
        </div>
      </ed-checkbox>
    </div>
  </ng-template>

  <ng-template ng-multi-label-tmp let-items="items">
    @for(item of items | slice : 0 : 1; track item) {

    <div class="ng-value selected-element">
      {{
        useTranslations
          ? ($any(item)[bindLabel] | transloco)
          : $any(item)[bindLabel]
      }}
    </div>
    } @if(items.length > 1) {

    <div class="ng-value overflow-label">
      <span class="ng-value-label overflow-label"
        >+ {{ items.length - 1 }}</span
      >
    </div>
    }
  </ng-template>
</ng-select>
